import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DataURL } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { LegendItemComponent } from '../legend-item.component';

export type LegendItemClass = {
  class_name: string;
  criteria1: string;
  criteria2: string;
  criteria3: string;
  icon: DataURL;
  component?: LegendClassComponent;
  image?: HTMLImageElement;
}

@Component({
  selector: 'app-legend-class',
  templateUrl: './legend-class.component.html',
  styleUrls: ['./legend-class.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class LegendClassComponent implements OnInit {

  public updated = true;
  @HostBinding('class.active') isActive = false;
  @HostBinding('class.is-vis') isVisClass = true;
  @HostBinding('class.is-not-vis') isNotVisClass = false;

  @Input()
  public item: LegendItemClass = {
    class_name: '',
    criteria1: '',
    criteria2: '',
    criteria3: '',
    icon: '/assets/images/empty.png'
  }
  @Input()
  public layer: SLLayer;
  @ViewChild('swatch', { static: true }) swatch: ElementRef<HTMLImageElement>;
  @Output() ready = new EventEmitter<LegendClassComponent>();
  @Output() clicks = new EventEmitter<LegendItemClass>();


  public get isVis(): boolean {
    let className = this.item.class_name;
    if (className === '') {
      className = this.layer.constructor.name.toLowerCase();
    }
    const visClass = this.layer.exclusions.IsExcluded(className) ? 'not-is-vis' : 'is-vis';
    this.isVisClass = visClass === 'is-vis';
    this.isNotVisClass = visClass === 'not-is-vis';
    // if(this.item.class_name === '') return true;
    return !this.layer.exclusions.IsExcluded(className);
  }


  private _ready = false;
  constructor(private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.item.component = this;
    if (this.item.class_name === '') {
      //for(const layerClass of this.layer.classification) {
      this.layer.exclusions.ToggleExclusion(this.layer.constructor.name.toLowerCase(), false);
      //}
      // this.item.class_name = this.layer.constructor.name.toLowerCase();
    }
    this._ready = true;
    this.Refresh();
  }
  ToggleVis() {
    this.layer.exclusions.ToggleExclusion(this.item.class_name);
    if (this.item.class_name === "") {
      //for(const layerClass of this.layer.classification) {
      this.layer.exclusions.ToggleExclusion(this.layer.constructor.name.toLowerCase());
      //}
      //}
      this.cdr.markForCheck();

    }
    this.layer.Render();
    this.Refresh();
  }
  GetIcon() {
    return this.item.icon;
  }
  GetSwatchURL() {
    return (this.swatch.nativeElement as any).toDataURL();
  }
  ImageLoaded(img: HTMLImageElement) {
    this.item.image = img;
    this.cdr.markForCheck();
    this.Refresh();
    this.ready.emit(this);
  }
  HandleClick(event) {
    event.stopImmediatePropagation();
    event.preventDefault();
    this.isActive = !this.isActive;
    this.Refresh();
    this.clicks.emit(this.item);
  }

  Refresh() {
    this.cdr.detectChanges();
  }

}
